export const CustomerReadinessQueryKeys = {
  all: () => ["customer-readiness"],
  single: (customerId: string) => [
    ...CustomerReadinessQueryKeys.all(),
    customerId,
  ],
};
